import { getRgObjectsOfType as a, RG_TYPE as n } from "@project-rouge/rg-core";
import { getApartmentCategoryCounts as m } from "./index.js";
const s = (t, e) => {
  const r = a(t, n.Apartment).filter((o) => o.data.level === e);
  return m(r);
};
export {
  s as getLevelApartmentCategoryCounts
};
//# sourceMappingURL=index3.js.map
